import { useState } from "react";
import { useTranslation } from "react-i18next";

const items = [1, 2, 3, 4, 5, 6];

export default function FaqAccordion() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {items.map((i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="text-sm font-semibold text-foreground-900">{t(`faq.q${i}`)}</span>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className={`ri-add-line text-sm transition-transform ${isOpen ? "rotate-45" : ""}`}></i>
              </span>
            </button>
            {isOpen && (
              <div className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                {t(`faq.a${i}`)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}